import React from 'react'
import GoldSiverHeader from '../HomePage/GoldSiverHeader'

function Select() {
    return (
        <div>
            <GoldSiverHeader previous={'/home'} title='Select'>
                <section class="ar_select_area_section_wrapper">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="ar_select_area">
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/ch1.png" alt="images"/></a>
                                        <div class="ar_select_img_cont">
                                            <p>unii210</p>
                                            <p>Lv. <span>90</span></p>
                                        </div>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/ch2.png" alt="images"/></a>
                                        <div class="ar_select_img_cont">
                                            <p>Sindy</p>
                                            <p>Lv. <span>90</span></p>
                                        </div>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>
                                    <div class="ar_single_select_item">
                                        <a href="#"><img src="/images/select/chbl.png" alt="images"/></a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </GoldSiverHeader>
        </div>
    )
}

export default Select
